import React, {useState} from 'react'
import {Box} from '@mui/material'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import PaymentIcon from '@mui/icons-material/Payment'
import {getVendorGatewayMeta} from '../../constants/vendorGatewayLogos'

export default function VendorGatewayLogo({
  factoryName,
  size = 40,
}: {
  factoryName: string
  size?: number
}) {
  const meta = getVendorGatewayMeta(factoryName)
  const [failed, setFailed] = useState(false)
  const color = meta?.color || 'var(--bs-primary)'
  const type = meta?.type

  return (
    <Box
      sx={{
        width: size,
        height: size,
        minWidth: size,
        borderRadius: '8px',
        bgcolor: meta?.backgroundColor || `${color}14`,
        border: `1px solid ${color}33`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        transition: 'transform 0.2s ease',
        '&:hover': {transform: 'scale(1.05)'},
      }}
    >
      {meta?.logo && !failed ? (
        <Box
          component='img'
          src={meta.logo}
          alt={`${meta.name}_logo`}
          onError={() => setFailed(true)}
          sx={{maxWidth: '75%', maxHeight: '75%', objectFit: 'contain'}}
        />
      ) : type === 'card' ? (
        <CreditCardIcon sx={{color, fontSize: size * 0.55}} />
      ) : type === 'wallet' ? (
        <AccountBalanceWalletIcon sx={{color, fontSize: size * 0.55}} />
      ) : (
        <PaymentIcon sx={{color, fontSize: size * 0.55}} />
      )}
    </Box>
  )
}
